import React from "react";
import { motion } from "framer-motion";
import "./Hero.css";
import heroImage from "../assets/hero.webp"; // ✅ import from assets

const Hero = () => {
  return (
    <section id="Home" className="hero-section">
    {/* Background Image */}
      <motion.div
        className="hero-bg"
        style={{ backgroundImage: `url(${heroImage})` }} // ✅ applied here
        whileHover={{ scale: 1.05 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      />

      {/* Glass Content */}
      <motion.div
        className="hero-content"
        initial={{ opacity: 0, x: -80 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <h1>
          Acence <br /> Making Your Brand Fly
        </h1>

        <p>Elevate Your Experience with Acence</p>

   <motion.a
  href="https://wa.me/917217647341"
  target="_blank"
  rel="noopener noreferrer"
  whileHover={{ scale: 1.05 }}
  whileTap={{ scale: 0.95 }}
  className="connect-btn"
>
  Connect Now
</motion.a>
      </motion.div>
    </section>
  );
};

export default Hero;
